import {
  HIDE_MT_AGENCIES_LIST_LOADER,
  HIDE_MT_BANNERS_LIST_LOADER, HIDE_MT_CAMPAIGNS_LIST_LOADER,
  HIDE_TIKTOK_ADVERTISERS_LIST_LOADER,
  HIDE_VK_BANNERS_LIST_LOADER,
  HIDE_VK_CAMPAIGNS_LIST_LOADER,
  HIDE_VK_CLIENT_LOADER, INTEGRATION_STATE_INIT,
  SET_MT_AGENCIES_LIST,
  SET_MT_BANNERS_LIST,
  SET_MT_CAMPAIGNS_LIST,
  SET_TIKTOK_ADVERTISERS_LIST,
  SET_VK_BANNER_LIST,
  SET_VK_CAMPAIGNS_LIST,
  SET_VK_CLIENT_LIST,
  SHOW_MT_AGENCIES_LIST_LOADER,
  SHOW_MT_BANNERS_LIST_LOADER,
  SHOW_MT_CAMPAIGNS_LIST_LOADER,
  SHOW_TIKTOK_ADVERTISERS_LIST_LOADER,
  SHOW_VK_BANNERS_LIST_LOADER,
  SHOW_VK_CAMPAIGNS_LIST_LOADER,
  SHOW_VK_CLIENT_LOADER
} from "./actionTypes";

const INIT_STATE = {
  dataCampaignVk: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  dataClientVk: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  dataBannerVk: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  dataAdvertisersTikTok: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  dataAgenciesMT: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  dataBannersMT: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  dataCampaignsMT: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  loading_campaign_vk: false,
  loading_client_vk: false,
  loading_banner_vk: false,
  loading_advertisers_tiktok: false,
  loading_agencies_mytarget: false,
  loading_banners_mytarget: false,
  loading_campaigns_mytarget: false,
  // success: null,
  error: null,
};

const Integration = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INTEGRATION_STATE_INIT:
      return {
        ...INIT_STATE
      };
    case SET_VK_CAMPAIGNS_LIST:
      return {
        ...state,
        dataCampaignVk: action.payload,
      };
    case SHOW_VK_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading_campaign_vk: true,
      };
    case HIDE_VK_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading_campaign_vk: false,
      };
    case SET_VK_CLIENT_LIST:
      return {
        ...state,
        dataClientVk: action.payload
      }
    case SHOW_VK_CLIENT_LOADER:
      return {
        ...state,
        loading_client_vk: true
      }
    case HIDE_VK_CLIENT_LOADER:
      return {
        ...state,
        loading_client_vk: false
      }
    case SET_VK_BANNER_LIST:
      return {
        ...state,
        dataBannerVk: action.payload
      }
    case SHOW_VK_BANNERS_LIST_LOADER:
      return {
        ...state,
        loading_banner_vk: true
      }
    case HIDE_VK_BANNERS_LIST_LOADER:
      return {
        ...state,
        loading_banner_vk: false
      }
    case SET_TIKTOK_ADVERTISERS_LIST:
      return {
        ...state,
        dataAdvertisersTikTok: action.payload
      }
    case SHOW_TIKTOK_ADVERTISERS_LIST_LOADER:
      return {
        ...state,
        loading_advertisers_tiktok: true
      }
    case HIDE_TIKTOK_ADVERTISERS_LIST_LOADER:
      return {
        ...state,
        loading_advertisers_tiktok: false
      }
    case SET_MT_AGENCIES_LIST:
      return {
        ...state,
        dataAgenciesMT: action.payload
      }
    case SET_MT_BANNERS_LIST:
      return {
        ...state,
        dataBannersMT: action.payload
      }
    case SET_MT_CAMPAIGNS_LIST:
      return {
        ...state,
        dataCampaignsMT: action.payload
      }
    case SHOW_MT_AGENCIES_LIST_LOADER:
      return {
        ...state,
        loading_agencies_mytarget: true
      }
    case HIDE_MT_AGENCIES_LIST_LOADER:
      return {
        ...state,
        loading_agencies_mytarget: false
      }
    case SHOW_MT_BANNERS_LIST_LOADER:
      return {
        ...state,
        loading_banners_mytarget: true
      }
    case HIDE_MT_BANNERS_LIST_LOADER:
      return {
        ...state,
        loading_banners_mytarget: false
      }
    case SHOW_MT_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading_campaigns_mytarget: true
      }
    case HIDE_MT_CAMPAIGNS_LIST_LOADER:
      return {
        ...state,
        loading_campaigns_mytarget: false
      }
    default:
      return state;
  }
};

export default Integration;
